<template>
  <div class="my-favorites">
    <Loader :visible="loading"></Loader>
    <div>
      <img :src="event.banner_url" class="banner">
    </div>
    <div class="container-fluid mt-30">
      <div class="row">
        <div class="col-sm-6">
          <h4>
            {{$t("myFavorites.title")}} ({{totalPhotos}})
            <i class="fa fa-cloud-download" @click="download"></i>
          </h4>
        </div>
        <div class="col-sm-6">
          <Select2Form v-model="eventId"
            :options="events"
            :allowClear="false">
          </Select2Form>
        </div>
      </div>
      <hr/>
      <div class="row">
        <div class="col-sm-10"></div>
        <div class="col-sm-2">
          <button class="button-search" @click="goToEvent">
            {{$t("myFavorites.goToEvent")}}
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div id="mosaicGallery" class="justified-gallery">
            <FavoritePhoto
              v-for="photo in photos"
              :key="photo.id"
              :photo="photo"
              :share-social-media="shareSocialMedia">
            </FavoritePhoto>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../../components/Loader';
import { mapGetters, mapActions } from 'vuex';
import justifiedGallery from 'justifiedGallery';
import FavoritePhoto from '../../components/FavoritePhoto';
import Select2Form from '../../components/Select2Form';

export default {
  name: "User.MyFavorites",
  data() {
    return {
      loading: true,
      photos: [],
      events: [],
      eventId: -1,
      event: {},
      defaultEvent: {},
      shareSocialMedia: false
    }
  },
  components: {
    FavoritePhoto,
    Select2Form,
    Loader
  },
  async created() {
    this.shareSocialMedia = this.currentPreference.share_social_media
    let events = await this.fetchEvents()
    this.defaultEvent = [{
      id: "-1",
      name: this.$t("myFavorites.showAll"),
      text: this.$t("myFavorites.showAll"),
      banner_url: "",
      logo_url: ""
    }]
    if(events.length > 0) {
      const event = events[0]
      this.defaultEvent.id = event.id
      this.defaultEvent.banner_url = event.banner_url
      this.defaultEvent.logo_url = event.logo_url
      this.event = this.defaultEvent
    }
    events = [...this.defaultEvent, ...events]
    this.events = events
    this.search()
    this.loading = false

    this.$root.$on('FavoritesAddPhotoToCart', this.addToCart)
    this.$root.$on('FavoritesRemovePhoto', this.removePhoto)
  },
  methods: {
    ...mapActions('ShoppingCartStore', ['addShoppingCartItem']),

    async addToCart(photo) {
      const params = { event_id: photo.event_id, photo_id: photo.id };
      this.$alertify.success(this.$t("checkout.addedItem"));
      await this.addShoppingCartItem(params);
      this.$root.$emit("addItemToCart", params);
    },
    async download() {
      try {
        this.loading = true

        const response = await this.$http.get(`/api/v2/users/download_album`, {
          params: {event_id: this.eventId}
        })

        if(response.status == 200 || response.status == 304) {
          location.href = response.data.url
        }
      } catch (e) {
        console.log(e)
        this.$alertify.error("Error")
      } finally {
        this.loading = false
      }
    },
    async fetchEvents() {
      try {
        const response = await this.$http.get(`/api/v2/users/favorites_events`)

        if(response.status == 200 || response.status == 304) {
          return response.data.events
        } else {
          return []
        }
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async fetchPhotos() {
      try {
        const response = await this.$http.get(`/api/v2/users/favorites_photos`, {
          params: {event_id: this.eventId}
        })

        if(response.status == 200 || response.status == 304) {
          return response.data.photos
        } else {
          return []
        }
      } catch (e) {
        console.log(e)
        return []
      }
    },
    async search() {
      this.loading = true
      this.photos = await this.fetchPhotos()
      this.render()
      this.loading = false
    },
    findEvent(eventId) {
      return this.events.find((event) => {
        return event.id == eventId
      })
    },
    goToEvent() {
      this.$router.push({
        name: "ShowEvent",
        params: {id: this.event.id}
      })
    },
    removePhoto(photo) {
      let index = 0
      this.photos.forEach((el, i) => {
        if(el.id == photo.id) {
          index = i
        }
      })
      this.photos.splice(index, 1)
      this.render()
    },
    render() {
      this.$nextTick(() => {
        $("#mosaicGallery").justifiedGallery({
          lastRow:    "nojustify",
          margins:    15,
          rowHeight:  150,
          randomize:  false,
          target:     false
        });
      })
    }
  },
  watch: {
    eventId(val, oldVal) {
      if(val != "" && val != oldVal) {
        if(val == -1) {
          this.event = this.defaultEvent
        } else {
          this.event = this.findEvent(val)
        }
        this.search()
      }
    }
  },
  computed: {
    ...mapGetters('Preference', ['currentPreference']),
    totalPhotos() {
      return this.photos.length
    }
  }
}
</script>

<style lang="scss" >
  .my-favorites {
    h4 {
      padding-left: 18px;
      font-weight: normal;
    }

    .select2-container .select2-selection--single {
      height: 33px !important;
    }

    .select2-container--default .select2-selection--single .select2-selection__rendered {
      line-height: 33px;
    }

    .select2-selection__arrow {
      height: 30px !important;
    }

    .fa-cloud-download {
      cursor: pointer;
    }
  }
</style>
